import _ from 'underscore';
import { mapState } from 'vuex';

export default {
	name: 'payment_preview',
	props: {
		payment : Object
	},

	components : {
		
	},

	data : function(){

		return {}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		
	},
	computed: mapState({
		
		auth : state => state.auth,

		menu : function(){


			return this.core.user.extendByFeaturesMenu(_.filter([
				{
					text: 'plans.paymentinfo',
					icon: 'fas fa-info-circle',
					action: this.info,
		
					features : ['admin']
				}, this.payment.cancelled == 0 ? {
					text: 'plans.refund',
					icon: 'fas fa-undo-alt',
					action: this.refundQuestion,
		
					features : ['admin']
				} : null
			], v => {return v}))

		}
	}),

	methods : {

		menuClick : function(){
			this.core.vueapi.listmenu(this.menu)
		},

		refund : function(value){

			
			this.$store.commit('globalpreloader', true)

			this.core.api.payments.admin.refund({id : this.payment.id, value}).then(() => {

				this.$store.commit('icon', {
					icon: 'success'
				})
				this.$emit('changed')
				this.$emit('close')

			}).catch(e => {

				this.$store.commit('icon', {
					icon: 'error',
					message: this.$t(e.error || "errors.general")
				})

			}).finally(() => {
				this.$store.commit('globalpreloader', false)
			})


			
		},
		refundQuestion : function(){

			this.core.vueapi.edit({
				ignoreerrors : false,
				schema : {
					fields : [

						{
							text : 'plans.refundValueName',
							id : 'refundValue',
							input : 'input',
							type : 'number',
							rules: [{
								rule: 'required',
							},{
								message : 'fields.refundValueRule1',
								rule : 'greater_than:-1'
							},{
								message : 'fields.refundValueRule2',
								rule : 'less_than:' + Number((this.payment.value / 100).toFixed(0))
							}]
						}
						
					]
				}
			}, {
				save : (r) => {

					this.$dialog.confirm(
						this.$t('plans.refundQuestion') + (' ('+r.refundValue+')'), {
						okText: this.$t('yes'),
						cancelText : this.$t('no')
					})
			
					.then((dialog) => {

						this.refund(r.refundValue * 100)

					}).catch( e => {
						
					})
				}
			})


			

		},

		info : function(){
			this.core.vueapi.paymentinfo({payment : this.payment})
		}
	},
}